import React from 'react'
import { Element } from 'react-scroll'
// @ts-ignore
import Fade from 'react-reveal/Fade';

export const OwnerView = () =>
  <Fade left cascade duration={500} delay={400} distance="40px">
    <section className="content">
      <Element name="page-owner" className="content--standard ownerView">
        <div className="ownerView--titleArea">
          <h3 className="ownerView--titleArea__title">創業者の想い</h3>
        </div>
        <section className="ownerView--mainArea">
          <div className="ownerView--mainArea--detailArea">
            <h4 className="ownerView--mainArea--detailArea__title" translate='no'>
              歯科医療従事者とIT企業でテクノロジーを開発し、新しい時代をつくる。
            </h4>
            <p translate='no' className="ownerView--mainArea--detailArea__description">
              私がこの事業を立ち上げたのは、マウスピース矯正をしたが治らなかったことがきっかけです。<br/>
              矯正治療をしている中で、噛み合わせに違和感がありそれを歯科医師に伝えたところ、「返金しましょうか？」と言われました。<br/>
              お金を返して欲しいわけではなく、歯ならびを治して欲しかったため、私はショックを受けて開いた口が塞がらず、その歯科医院に通うことを辞めました。<br/>
              そこから私はなぜ治らなかったのか調べ、自分の受けていた治療に不足があったことを知りました。<br/>
              こんな治療が広まって欲しくない。しっかり治療できる矯正サービスを立ち上げようと考えたのがhanalove(はならぶ)です。是非、私たちの話を一度聞いていただけますと幸いです。<br/>
            </p>
            <p className="ownerView--mainArea--detailArea__name" translate='no'>Deltan株式会社　代表取締役 井上佳洋</p>
          </div>
        </section>
      </Element>
    </section>
  </Fade>